var arabam;
(function (arabam) {
    function initializeBreadcrumbSticky() {
        var ticking = false;
        var topPos = 0;
        window.addEventListener("scroll", function () {
            // NOTE: we get the element inside event because re-rendering on search
            var breadcrumbShell = document.getElementById("breadcrumbShell");
            //let breadcrumbSticky = breadcrumbShell.querySelector(".breadcrumb-sticky") as HTMLElement;
            // check if auction banner active.
            var auctionBar = document.getElementById("js-hook-for-scroll-class-aab");
            var buyNowBar = document.getElementById("js-hook-buy-now-container");
            if (auctionBar && auctionBar.offsetHeight > 0 && buyNowBar && buyNowBar.offsetHeight > 0) {
                topPos = auctionBar.offsetHeight + buyNowBar.offsetHeight;
                if (breadcrumbShell)
                    breadcrumbShell.classList.add("auction-buyNow-on-page");
            }
            else if (auctionBar && auctionBar.offsetHeight > 0) {
                topPos = auctionBar.offsetHeight;
                if (breadcrumbShell)
                    breadcrumbShell.classList.add("auction-on-page");
            }
            else if (buyNowBar && buyNowBar.offsetHeight > 0) {
                topPos = buyNowBar.offsetHeight;
                if (breadcrumbShell)
                    breadcrumbShell.classList.add("buyNow-on-page");
            }
            // console.log("topPos:", topPos);
            if (!ticking && breadcrumbShell) {
                window.requestAnimationFrame(function () {
                    if (breadcrumbShell.getBoundingClientRect().top <= 5) {
                        breadcrumbShell.classList.add("sticky");
                        // auctionBarHeight is not static so this cause junky movement
                        // breadcrumbSticky.style.top = topPos + "px";
                    }
                    else {
                        breadcrumbShell.classList.remove("sticky");
                        // breadcrumbSticky.style.top = "0px";
                    }
                    ticking = false;
                });
                ticking = true;
            }
        });
    }
    arabam.initializeBreadcrumbSticky = initializeBreadcrumbSticky;
    if (window.configuration && !window.configuration.IsMobile) {
        initializeBreadcrumbSticky();
    }
})(arabam || (arabam = {}));
